export default __webpack_public_path__ + "static/background-6c1520cbfa22be42cd9a2131b3b5c186.mp4";